"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rcPreferencesActions = void 0;
var _locale = require("../../../utils/locale");
var _slice = require("./slice");
const {
  inject
} = _slice.rcPreferencesSlice.actions;
const infer = () => dispatch => {
  const supportedBrowserLanguage = navigator.languages.reduce((supportedLanguage, browserLanguage) => {
    if (supportedLanguage) {
      return supportedLanguage;
    }
    const adaptedLanguage = (0, _locale.getAdaptedLocale)(browserLanguage);
    if ((0, _locale.getIsLocaleSupported)(adaptedLanguage)) {
      return adaptedLanguage;
    }
    return null;
  }, null);
  const {
    language: defaultBrowserLanguage
  } = navigator;
  const adaptedLanguage = supportedBrowserLanguage || (0, _locale.getAdaptedLocale)(defaultBrowserLanguage);
  dispatch(inject({
    locale: adaptedLanguage
  }));
};
const rcPreferencesActions = exports.rcPreferencesActions = {
  inject,
  infer
};